import { render, staticRenderFns } from "./PayPalSubscribeButtons.vue?vue&type=template&id=425ed036&scoped=true&"
import script from "./PayPalSubscribeButtons.vue?vue&type=script&lang=ts&"
export * from "./PayPalSubscribeButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ed036",
  null
  
)

export default component.exports